/* eslint-disable react/display-name */
import { Author, OtherPage, Post, Snippet } from 'contentlayer/generated'
import { useMDXComponent } from 'next-contentlayer/hooks'
import React from 'react'
import { Tweet } from 'types/Twitter'
import Ad from './Ad'
import Callout from './Callout'
import Button from './Button'
import Image from './Image'
import CustomLink from './Link'
import Newsletter from './Newsletter'
import Pre from './Pre'
import Step from './Step'
import GradientText from './text/GradientText'
import TOCInline from './TOCInline'
import TweetCard from './TweetCard'
import TechStack from './TechStack'
import GithubActivity from './GithubActivity'
import TheOfficeQuote from './TheOfficeQuote'
import UnderConstruction from './UnderConstruction'
import { ImageProps } from 'next/image'

const Wrapper: React.ComponentType<{ layout: string }> = ({ layout, ...rest }) => {
  const Layout = require(`../layouts/${layout}`).default
  return <Layout {...rest} />
}

const BlogImage = (props: ImageProps) => {
  const caption = props.alt ?? ''
  return (
    <figure>
      <Image {...props} alt={caption || 'A visual depiction of what is being written about'} />
      {caption && (
        <figcaption className="text-center dark:text-gray-300 text-gray-600">{caption}</figcaption>
      )}
    </figure>
  )
}

const BlockQuote = (props: any) => {
  return <Callout type="info" {...props}></Callout>
}

export const MDXComponents = {
  Image: BlogImage,
  TOCInline,
  a: CustomLink,
  blockquote: BlockQuote,
  Link: CustomLink,
  pre: Pre,
  wrapper: Wrapper,
  Step,
  Ad,
  GradientText,
  Newsletter,
  Callout,
  Button,
  TechStack,
  GithubActivity,
  UnderConstruction,
  TheOfficeQuote,
}

interface Props {
  layout: string
  content: Post | Author | Snippet | OtherPage
  tweets?: Tweet[]
  [key: string]: unknown
}

export const MDXLayoutRenderer = ({ layout, content, tweets = [], ...rest }: Props) => {
  const MDXContent = useMDXComponent(content.body.code)
  const StaticTweet = ({ id }) => {
    const tweet = tweets.find((tweet) => tweet.id === id)
    if (!tweet) {
      return null
    }
    return <TweetCard {...tweet} />
  }

  return (
    <MDXContent
      layout={layout}
      content={content}
      components={{ ...MDXComponents, StaticTweet }}
      {...rest}
    />
  )
}
